/**
* 社区分享页面
*/
<template>

	<div>
		<head>
			<title>你的网页标题</title>
		</head>
		<body style="max-width: 400px; margin: 0 auto;">

			<!-- 打开QIUI 没有打开成功 就跳转其他页面 -->
			<van-overlay :show="loading" @click="show = false">
				<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
					<van-loading size="24px" vertical>{{ $t('language000002') }}</van-loading>
				</div>
			</van-overlay>


			<!-- 数据加载提示框 -->
			<van-overlay :show="loadingData" @click="show = false">
				<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
					<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
				</div>
			</van-overlay>


			<!-- 打开QIUI -->
			<div class="open-qiui-div-bg-community" @click="openQIUI">
				<div class="open-qiui-div-button-community">
					<img style="width: 30px; height: 30px;" src="../assets/main03_sys.jpg">
					<span class="open-qiui-div-span-community">{{ $t('language000039') }}</span>
					<img style="width: 13px; height: 13px;" src="../assets/right_grey.png" />
				</div>
			</div>


			<!-- 标题 社区分享 -->
			<div style="text-align: center; margin-top: 15px; margin-bottom: 10px;">
				<span style="font-size: 18px; font-weight: bold; color: black;">{{ $t('language000001') }}</span>
			</div>


			<!-- 用户资料 -->
			<div style="height: 50px; display: flex; align-items: center; padding: 0 10px;">
				<div>
					<van-image round width="45px" height="45px" :src="avatar" />
				</div>

				<div style="margin-left: 8px; height: 100%; margin-top: 2px;">
					<div style="text-align: left;">
						<span
							style="margin-left: 3px; font-size: 14px; font-weight: bold; color: #000;">{{ nickName }}</span>
					</div>
					<div style="display: flex; align-items: center; margin-top: 4px;">
						<div :style="{ 'background-color': sexBackgroundColor }"
							style="border-radius: 10px; padding: 2px 6px; display: flex; align-items: center;">
							<img style="width: 13px; height: 13px;" :src="sexImage">
							<span :style="{'color':sexTextColor }"
								style="font-size: 11px; margin-left: 3px; font-weight: bold;">{{ age }}</span>
						</div>
						<span style=" padding: 0 5px; font-size: 11px; font-weight: bold; color: #999;">/</span>
						<span style=" font-size: 11px; font-weight: bold; color: #999;">{{ sexOrientation }}</span>
						<span style=" padding: 0 5px; font-size: 11px; font-weight: bold; color: #999;">/</span>
						<span style=" font-size: 11px; font-weight: bold; color: #999;">{{ attribute }}</span>
					</div>
				</div>
			</div>


			<!-- 帖子的内容 -->
			<span style="padding: 5px 10px; font-size: 14px;">{{ topicContent }}</span>


			<!-- 音频文件 -->
			<div v-if="shouldShowAudio" style="display: flex; align-items: center; margin-top: 5px; padding: 0 10px;">
				<audio style="height: 30px;" :src="audioUrl" ref="audio" controls></audio>
				<button
					style="margin-left: 5px; font-size: 10px; background-color: #f7f7f7; border-radius: 10px; border: none;"
					@click="playPauseAudio">{{ $t('language000040') }}</button>
			</div>


			<!-- 九宫图片布局 -->
			<div class="grid-container" style="padding: 10px;">
				<!-- 使用v-for遍历topicImages数组 -->
				<div v-for="(image, index) in topicImages" :key="index" class="grid-item">
					<div class="image-container">
						<img :src="image.topicImgUrl" alt="Topic Image" class="responsive-image" />
						<!-- <span>{{ image.topicImgUrl }}</span> -->
					</div>
				</div>
			</div>


			<!-- 视频 -->
			<div v-if="shouldShowVideo">
				<video controls width="300px" height="300px" style="margin-bottom: 10px;">
					<source :src="videoUrl" type="video/mp4">
				</video>
			</div>


			<!-- 商城动态帖子 -->
			<div v-if="isShowShop" @click="goToCommodity()"
				style="height: 45px; background-color: #f7f7f7; border-radius: 10px; display: flex; align-items: center; padding: 3px 0px;">
				<!-- 商品图片 -->
				<van-image style="margin-left: 10px; border-radius: 5px;" round width="40px" height="40px"
					:src="prodPicture" />
				<!-- 商品名称 -->
				<div style="margin-left: 10px; width: 83%;">
					<span
						style="font-size: 12px; color: #000; display: block;white-space: nowrap;overflow: hidden; text-overflow: ellipsis;">{{prodName}}</span>
					<div style="display: flex; align-items: center; margin-top: 2px;">
						<span style="font-size: 12px; color: #FC5656;">{{currency}}</span>
						<span style="font-size: 14px; font-weight: bold; color: #FC5656;">{{price}}</span>
						<!-- 图片 -->
						<div style="text-align: right; width: 100%;">
							<img style="width: 45px; height: 20px; " src="../assets/share_products_image.png" />
						</div>
					</div>
				</div>
			</div>


			<!-- 多久之前发布的帖子 -->
			<div style="text-align: right;padding: 5px 10px;">
				<span style="font-size: 11px; color: #999;">{{ postTime }}</span>
			</div>


			<!-- 浏览量+关注量+评论量 -->
			<div style="display: flex;align-items: center; padding: 0 10px;">
				<img :src="post_browse" width="17px" height="15px">
				<span style="margin-left: 2px; font-size: 13px; color: #999;">{{ viewCount }}</span><!-- 浏览量 -->

				<div style="margin-left: auto;display: flex;align-items: center;">
					<img :src="post_collection_no" width="17px" height="13px" style="margin-left: 30px;">
					<span style="margin-left: 2px; font-size: 13px; color: #999;">{{ likeCount }}</span><!-- 点赞输 -->

					<img :src="post_message" width="17px" height="13px" style="margin-left: 30px;">
					<span style="margin-left: 2px; font-size: 13px; color: #999;">{{ commentCount }}</span><!-- 评论数 -->
				</div>
			</div>


			<!-- 评论列表 -->
			<div style="padding: 15px 10px;">
				<ul>
					<li v-for="(comment, index) in topicComments" :key="index">
						<!-- 评论人 -->
						<div style="height: 50px; display: flex; align-items: center;">
							<!-- 头像 -->
							<div>
								<van-image round width="45px" height="45px"
									:src="getAvatarSrc(comment.commentUserDetail.avatar)" />
							</div>
							<!-- 昵称+发布时间+点赞数 -->
							<div style="margin-left: 10px; width: 100%;">
								<div>
									<span
										style="font-size: 13px; color: #666;">{{ comment.commentUserDetail.nickName }}</span>
								</div>
								<div>
									<span
										style="font-size: 11px; color: #999;">{{ timeConversion(comment.postTime) }}</span>
									<div style="float: right; margin-top: -5px; display: flex; align-items: center;">
										<img style="width: 17px; height: 15px;"
											src="../assets/post_collection_no.png" />
										<span
											style="margin-left: 2px; font-size: 13px; color: #999;">{{ comment.likeCount }}</span>
									</div>
								</div>
							</div>
						</div>
						<div style="display: flex; padding: 5px 0;">
							<!-- 楼层 -->
							<span
								style="width: 45px; font-size: 12px; color: #999; text-align: center;">{{ index+1 }}L</span>
							<!-- 评论内容 -->
							<span style="font-size: 14px; color: #333;">{{ comment.commentContent }}</span>
						</div>
						<!-- 线 -->
						<div
							style="margin-left: 45px; margin-right: 5px; border-bottom: 1px solid #F6F7F8; margin: 10px 0;">
						</div>

					</li>
				</ul>
			</div>

			<!-- //.. -->
		</body>
	</div>


</template>

<script>
	//执行顺序是beforeCreate -> created -> beforeMount -> mounted
	import axios from 'axios';
	import 'vant/lib/index.css'; //导入样式
	import Vue from 'vue';
	import {
		Image as VanImage
	} from 'vant';
	Vue.use(VanImage);

	// 引入公用方法
	import {
		getCurrencySymbol
	} from '@/utils/StringUtil';

	export default {
		name: 'Community',
		created() { // 在组件创建时触发，通常用于初始化数据
		},
		mounted() {
			// 在生命周期钩子中获取路由参数
			this.topicId = this.$route.params.topicId;
			this.userId = this.$route.params.userId;
			this.shareId = this.$route.params.shareId;

			const userLanguage = navigator.language || navigator.userLanguage; // 获取用户浏览器所配置的语言偏好
			//alert(userLanguage);
			const isLanguageSupported = this.$p_languages.includes(userLanguage); // 检查用户语言是否在支持的语言列表中
			// 如果语言受支持，则设置为用户语言，否则设置为默认语言
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage;

			this.fetchData();
			this.burialPointRecode();
		},
		data() {
			return {
				loading: false, // 是否显示加载效果 （打开qiui）
				loadingData: false, // 是否显示加载效果 (加载数据)
				topicId: null, //路由参数1
				userId: null, //路由参数2
				shareId: null, //路由参数3 分享者ID
				avatar: null, //用户头像
				nickName: null, //用户昵称
				age: null, //年龄
				sexOrientation: null, //性取向
				attribute: null, //属性
				topicContent: null, //帖子内容
				topicImages: [], //图片
				audioUrl: "", //音频路径
				shouldShowAudio: false, // 是否要展示这个音频 默认是不显示
				videoUrl: "", //视频路径
				shouldShowVideo: false, // 是否要展示这个视频 默认是不显示
				postTime: null, //发布时间
				post_browse: require('@/assets/post_browse.png'),
				viewCount: 0, //浏览量
				post_collection_no: require('@/assets/post_collection_no.png'),
				likeCount: 0, //点赞数
				post_message: require('@/assets/post_message.png'),
				commentCount: 0, //评论数
				topicComments: [], //评论数据
				sexBackgroundColor: "", //性别背景颜色
				sexImage: "", //性别背景
				sexTextColor: "", //性别年龄的文字颜色
				isShowShop: true, //是否显示商城的动态
				prodPicture: "", //商品图片
				prodName: "", //商品名称
				currency: 0, //商品价格
				price: "", //商品货币
				promotionProdId: null, //商品ID
			};
		},
		methods: {
			burialPointRecode() {
				axios.post(this.$p_url + '/feign/spread/burialPointRecode', {
						spreadUserId: this.shareId,
						topicId: this.topicId,
					}, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
						},
					})
					.then(response => {
						console.log("埋点的返回：", response.data)
					})
					.catch(error => { // 请求失败时处理错误
						console.error('Error fetching data:', error);
					});

			},
			fetchData() {
				this.loadingData = true;
				axios.post(this.$p_url + '/feign/spread/getSpreadCommunityTopicDetail', {
						topicId: this.topicId,
						userId: this.userId,
					}, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("返回的值：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							const data = response.data.data; // 获取数据
							//用户数据
							const userDetail = data.userDetail;
							this.nickName = userDetail.nickName;
							this.avatar = this.$p_urlImage + userDetail.avatar;
							this.age = userDetail.age; //年龄
							switch (this.sex) { //性别背景
								case 1:
									this.sexBackgroundColor = "#9BDFFC";
									this.sexImage = require('@/assets/sex01.png');
									this.sexTextColor = "#02A1FC";
									break
								case 2:
									this.sexBackgroundColor = "#FED7D7";
									this.sexImage = require('@/assets/sex02.png');
									this.sexTextColor = "#FC5E5E";
									break
								case 3:
									this.sexBackgroundColor = "#BEB5FC";
									this.sexImage = require('@/assets/sex03.png');
									this.sexTextColor = "#4A418C";
									break
								case 4:
									this.sexBackgroundColor = "#FBCE9A";
									this.sexImage = require('@/assets/sex04.png');
									this.sexTextColor = "#FA8F14";
									break
								default:
									this.sexBackgroundColor = "#A7F8D8";
									this.sexImage = require('@/assets/sex05.png');
									this.sexTextColor = "#0DBB76";
									break
							}


							switch (userDetail.sexOrientation) { //性取向
								case 1: //Bis
									this.sexOrientation = "BIS";
									break;
								case 2: //Hetero
									this.sexOrientation = "HETERO";
									break;
								case 3: //Gay
									this.sexOrientation = "GAY";
									break;
								case 4: //LES
									this.sexOrientation = "LES";
									break;
							}
							switch (userDetail.attribute) { //属性
								case 1: //Sado
									this.attribute = "SADO";
									break;
								case 2: //Mado
									this.attribute = "MASO";
									break;
								case 3: //Dom
									this.attribute = "DOM";
									break;
								case 4: //Sub
									this.attribute = "SUB";
									break;
								case 5: //Sw
									this.attribute = "SWITCH";
									break;
							}
							//帖子内容
							this.topicContent = data.topicContent;

							//判断图片是否为空
							if (data.topicImages !== null && data.topicImages !== undefined) {
								//图片前缀增加
								this.topicImages = data.topicImages.map(image => ({
									...image,
									topicImgUrl: this.$p_urlImage + image.topicImgUrl
								}));
								//打印
								/* this.topicImages.forEach(item => {
									console.log("获取000", item.topicImgUrl);
								}); */
							}

							//判断音频是否为空
							if (data.audioUrl !== null && data.audioUrl !== undefined) {
								this.audioUrl = this.$p_urlImage + data.audioUrl; //音频路径
								this.shouldShowAudio = true; //表示展示这个控件
							} else {
								this.shouldShowAudio = false; //表示隐藏这个控件
							}

							//判断是视频是否为空
							if (data.videoType == 1 && data.videoUrl !== null && data.videoUrl !== undefined) {
								this.videoUrl = this.$p_urlImage + data.videoUrl; //视频路径
								this.shouldShowVideo = true; //表示展示这个控件
							} else {
								this.shouldShowVideo = false; //表示隐藏这个控件
							}


							//判断是否为有商品
							if (data.type == 2) {
								this.isShowShop = true;
								this.prodPicture = this.$p_urlImage + data.promotionTopicInfo.prodPicture; //商品图片
								this.prodName = data.promotionTopicInfo.prodName; //商品昵称
								this.currency = getCurrencySymbol(data.promotionTopicInfo.currency); //商品货币
								this.price = data.promotionTopicInfo.price; //商品价格
								this.promotionProdId = data.promotionTopicInfo.promotionProdId; //商品ID
							} else this.isShowShop = false;


							//发布时间
							this.postTime = this.timeConversion(data.postTime);


							this.viewCount = data.topicCount.viewCount; //帖子浏览量
							this.likeCount = data.topicCount.likeCount; //点赞数
							this.commentCount = data.topicCount.commentCount; //评论数

							//评论
							this.topicComments = data.topicComments;


						} else { // 处理状态为失败的情况
							//alert("请求失败:" + response.data);
							console.error("请求失败：", response.data);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						console.error('Error fetching data:', error);
					});
			},
			playPauseAudio() {
				//手机端生产的音频文件 在代码里播放不了，其他的.mp3可以正常播放 所以这里跳转到其他网页进行播放
				window.open(this.audioUrl);
			},
			getAvatarSrc(avatar) {
				// 在这里进行字符串拼接
				return this.$p_urlImage + avatar;
			},
			timeConversion(time) { //时间转换处理
				const s = time.split("_");
				switch (s[1]) {
					case "s":
						s[1] = this.$t('language000041');
						break;
					case "m":
						s[1] = this.$t('language000042');
						break;
					case "h":
						s[1] = this.$t('language000043');
						break;
					case "d":
						s[1] = this.$t('language000044');
						break;
					case "M":
						s[1] = this.$t('language000045');
						break;
					case "y":
						s[1] = this.$t('language000046');
						break;
				}
				return s[0] + " " + s[1];
			},
			goToCommodity() { //跳转到店铺的分享页面
				this.$router.push({
					name: 'commodity',
					params: {
						pid: this.promotionProdId, //商品ID
					}
				});
			},
			openQIUI() { // 在这里可以添加打开 QIUI 的逻辑
				const a = document.createElement("a");
				a.href = this.$p_urlScheme + "postinfo?uid=" + this.topicId;

				this.loading = true; //显示加载中
				const u = navigator.userAgent;
				const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
				if (isiOS) { //IOS
					window.location.href = this.$p_urlScheme + "postinfo?uid=" + this.topicId; // ios对应的app协议
					setTimeout(() => {
						this.loading = false;
						//检测页面是否隐藏，通常用于判断用户是否切换到其他应用或标签。
						let hidden = window.document.hidden || window.document.mozHidden || window.document
							.msHidden || window.document.webkitHidden
						//如果页面未隐藏，表示用户留在当前页面。
						if (typeof hidden == "undefined" || hidden == false) {

							/* //跳转到注册页面
							this.$router.push({
								name: 'register'
							}); */

							//跳转到下载页面
							this.$router.push({
								name: 'download'
							});

						}
					}, 3000); //延迟3秒执行
				} else { //Android
					window.location.href = this.$p_urlScheme + "postinfo?uid=" + this.topicId; // 安卓对应的app协议
					setTimeout(() => {
						let hidden = window.document.hidden || window.document.mozHidden || window.document
							.msHidden || window.document.webkitHidden
						if (typeof hidden == "undefined" || hidden == false) {
							this.loading = false;

							/* //跳转到注册页面
							this.$router.push({
								name: 'register'
							}); */

							//跳转到下载页面
							this.$router.push({
								name: 'download'
							});

						}
					}, 3000); //延迟3秒执行
				}
			},
		}

	}
</script>

<style>
	/* 引入外部的CSS文件 */
	@import '../css/community.css';
</style>